import React from 'react';
import { H3 } from '@blueprintjs/core';

import { PpgExtractorData } from '../../types';

import { buildPpgChart } from '../../../../utils/buildLineCharts';

interface PpgExtractorProps {
  data: PpgExtractorData;
}

const PpgExtractor = ({ data }: PpgExtractorProps) => {
  return (
    <>
      <H3>Resultado do Algoritmo:</H3>
      <>
        {data.ppg.length > 0 &&
          buildPpgChart(data.ppg, 'PPG', 'BE4228', data.duration)}
      </>
    </>
  );
};

export default PpgExtractor;
